const headerSP = $('.l-header__sp')
const hamburgerMenu = $('.js-hamburger-menu')
const spMenu = $('.l-header__sp-menu')

// ハンバーガーメニュー
hamburgerMenu.on('click', function(e) {
  if (!spMenu.hasClass('open')) {
    spMenu.addClass('open')
    hamburgerMenu.addClass('open')
    headerSP.addClass('open')
    spMenu.fadeIn(300)
  } else {
    spMenu.removeClass('open')
    hamburgerMenu.removeClass('open')
    headerSP.removeClass('open')
    spMenu.fadeOut(300)
  }
})

// スクロール
$(window).on('scroll', function() {
  const scrollBottom = getScrollBottom()
  const pageTop = $('.c-pagetop')
  const fixedBottom = $('.c-conversion__sp-items')
  if ($(this).scrollTop() > 300) {
    pageTop.fadeIn()
    fixedBottom.fadeIn().css('display', 'flex')
  } else {
    pageTop.fadeOut()
    fixedBottom.fadeOut()
  }

  if (scrollBottom < 445) {
    pageTop.removeClass('fixed')
  } else {
    pageTop.addClass('fixed')
  }
})
// 下からの y の長さ
function getScrollBottom() {
  var body = window.document.body
  var html = window.document.documentElement
  var scrollTop = body.scrollTop || html.scrollTop
  return html.scrollHeight - html.clientHeight - scrollTop
}

// 先輩社員インタビュー、お仕事特集 #アンカーリンク
const headerH = 120 //ヘッダーの高さ
$(window).on('load', function(e) {
  if (location.hash !== '') {
    let targetOffset = $(location.hash).offset().top
    let speed = 400
    let position = targetOffset - headerH
    $('html, body').animate({ scrollTop: position }, speed, 'swing')
    e.preventDefault()
  }
})

// お仕事特集 SPヘッダー アンカーリンク 同ページ内だったとき
$('.js-sp-header-anchor-features').on('click', function(e) {
  spMenu.removeClass('open')
  hamburgerMenu.removeClass('open')
  headerSP.removeClass('open')
  spMenu.fadeOut(300)
  let speed = 400
  let target = $('#features')
  let position = target.offset().top - headerH
  $('html, body').animate({ scrollTop: position }, speed, 'swing')
  e.preventDefault()
})

// 住所入力
$(function() {
  $('[name="your-zip"]').on('keyup', function() {
    AjaxZip3.zip2addr(this, '', 'your-address', 'your-address')
  })
})

// エントリーフォーム 求人詳細へ戻る
let subPass = '/'
if (location.host.match(/flares/)) {
  subPass = '/cad/'
}
$('button[name="goto_job"]').on('click', function() {
  const url = subPass + 'jobs/' + $(this).val() + '.html'
  window.location.href = url
})
if (!$('input[name="submitConfirm"]').length) {
  $('button[name="goto_job"]').hide()
}
if ($('input[name="your-age"]').length) {
  $('input[name="your-age"]').after(' 才')
}
